import React, { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { GetAllWEBFAQforWeb } from "../APIs/APIHelperforWeb";

const allowedRoutes = [
  /^\/$/,
  /^\/home$/,
  /^\/[^/]+$/,
  /^\/property-details\/[^/]+$/,
  /^\/contact-us$/,
  /^\/privacy-policy$/,
  /^\/about-us$/,
  /^\/our-services$/,
  /^\/author\/[^/]+$/,
  /^\/blog-grid$/,
  /^\/blog-detail\/[^/]+$/,
];

const Faq = () => {
  const { pathname } = useLocation();
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);

  // 1. Check if the current route matches allowed routes
  const shouldRenderSchema = useMemo(() => {
    return allowedRoutes.some((pattern) => pattern.test(pathname));
  }, [pathname]);

  // Fetch FAQ data
  useEffect(() => {
    const loadFaqData = async () => {
      try {
        const cachedFaqs = localStorage.getItem("WEBFAQListforWeb");
        let data = [];

        if (cachedFaqs) {
          data = JSON.parse(cachedFaqs);
        }

        if (!Array.isArray(data) || !data.length) {
          data = await GetAllWEBFAQforWeb();
          if (Array.isArray(data) && data.length) {
            localStorage.setItem("WEBFAQListforWeb", JSON.stringify(data));
          }
        }

        setFaqData(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error loading FAQ schema data:", error);
        setFaqData([]);
      } finally {
        setLoading(false);
      }
    };

    loadFaqData();
    //Checkrender();
  }, []);

  // const Checkrender = () => {
  // debugger;
  // const storedCount = localStorage.getItem("faqcount");

  // let count = storedCount ? parseInt(storedCount, 10) : 0;
  // if (count === 0) {
  // localStorage.setItem("faqcount", "1");
  // return true;
  // } else {
  // count++;
  // localStorage.setItem("faqcount", count.toString());
  // return false;
  // }
  // };

  // 2. Map data to Schema structure
  const mainEntity = useMemo(() => {
    return faqData
      .filter((item) => item?.IsActive !== false)
      .map((faq, index) => {
        const question = faq?.Question || faq?.Title || `Question ${index + 1}`;
        const answer = faq?.Answer || faq?.Description || "";

        return {
          "@type": "Question",
          name: question,
          acceptedAnswer: {
            "@type": "Answer",
            text: answer,
          },
        };
      })
      .filter((item) => item.name && item.acceptedAnswer.text);
  }, [faqData]);

  // 3. Build the final schema object
  const schema = useMemo(() => {
    if (!mainEntity.length) return null;
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity,
    };
  }, [mainEntity]);

  // Determine validation criteria safely
  const canRenderSchema =
    shouldRenderSchema && pathname !== "/404" && !loading && schema;

  // Instead of returning null early, let Helmet handle the injection states smoothly
  return (
    <Helmet>
      {canRenderSchema ? (
        <script
          id="faq-schema"
          key="faq-schema" // Using BOTH id and key forces an update overwrite
          type="application/ld+json"
        >
          {JSON.stringify(schema)}
        </script>
      ) : null}
    </Helmet>
  );
};

export default Faq;
